import Hero from "@/components/Hero";
import HeadlinesStrip from "@/components/HeadlinesStrip";
import DailyBriefing from "@/components/DailyBriefing";
import TodaysGames from "@/components/TodaysGames";
import Scoreboards from "@/components/Scoreboards";
import TodayResults from "@/components/TodayResults";
import OddsBoard from "@/components/OddsBoard";
import CalendarCTA from "@/components/CalendarCTA";
import MetroplexGames from "@/components/MetroplexGames";
import Manifesto from "@/components/Manifesto";
import ScoreAlerts from "@/components/ScoreAlerts";
import TeamDirectory from "@/components/TeamDirectory";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <HeadlinesStrip />
      <DailyBriefing />
      <TodaysGames />
      <Scoreboards />
      <TodayResults />
      <OddsBoard />
      <CalendarCTA />
      <MetroplexGames />
      <ScoreAlerts />
      <Manifesto />
      <TeamDirectory />
    </main>
  );
}
